import AdjustIcon from '@mui/icons-material/Adjust'
import ClockIcon from '@mui/icons-material/AccessTime'
import CloseIcon from '@mui/icons-material/Close'
import HomeIcon from '@mui/icons-material/Home'
import PodIcon from '@mui/icons-material/FolderSpecial'
import MaterialIcon from '@mui/icons-material/AutoStories'
import ConversationIcon from '@mui/icons-material/QuestionAnswer'
import NotesIcon from '@mui/icons-material/EditNote'
import ActivityIcon from '@mui/icons-material/Insights'
import ReadingQuestionIcon from '@mui/icons-material/ContactSupport'
import ReplyIcon from '@mui/icons-material/Reply'
import TagIcon from '@mui/icons-material/Sell'
import PeopleIcon from '@mui/icons-material/Groups2'
import SettingsIcon from '@mui/icons-material/Settings'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import HelpIcon from '@mui/icons-material/Help'
import FolderIcon from '@mui/icons-material/FolderOutlined'
import FolderOpenIcon from '@mui/icons-material/FolderOpenOutlined'
import FileIcon from '@mui/icons-material/TextSnippetOutlined'
import DeleteIcon from '@mui/icons-material/Delete'
import DownloadIcon from '@mui/icons-material/Download'
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import SortByAlphaIcon from '@mui/icons-material/SortByAlpha'
import SortIcon from '@mui/icons-material/Sort'

export type IconIdType =
  "clock"|
  "close"|
  "delete"|
  "download"|
  "help"|
  "home"|
  "pod"|
  "podActivity"|
  "podAddFile"|
  "podAddFolder"|
  "podConversations"|
  "podFile"|
  "podFolder"|
  "podFolderOpen"|
  "podMaterial"|
  "podNotes"|
  "podPeople"|
  "podReadingQuestions"|
  "podSettings"|
  "podTags"|
  "reply"|
  "settings"|
  "sortByAlphabet"|
  "sortByFrequency"|
  "status";



const UxIcon = ({id, fontSize, sx}: {id: IconIdType, fontSize?: "small" | "medium" | "large", sx?: object}) => {
  const size = fontSize ? fontSize : "medium"

  if(id === "clock") return <ClockIcon fontSize={size} sx={{...sx}} />
  if(id === "close") return <CloseIcon fontSize={size} sx={{...sx}} />
  if(id === "delete") return <DeleteIcon fontSize={size} sx={{...sx}} />
  if(id === "download") return <DownloadIcon fontSize={size} sx={{...sx}} />
  if(id === "help") return <HelpIcon fontSize={size} sx={{...sx}} />
  if(id === "home") return <HomeIcon fontSize={size} sx={{...sx}} />
  if(id === "pod") return <PodIcon fontSize={size} sx={{...sx}} />

  if(id === "podActivity") return <ActivityIcon fontSize={size} sx={{...sx}} />
  if(id === "podAddFile") return <UploadFileIcon fontSize={size} sx={{...sx}} />
  if(id === "podAddFolder") return <CreateNewFolderIcon fontSize={size} sx={{...sx}} />
  if(id === "podConversations") return <ConversationIcon fontSize={size} sx={{...sx}} />
  if(id === "podFile") return <FileIcon fontSize={size} sx={{...sx}} />
  if(id === "podFolder") return <FolderIcon fontSize={size} sx={{...sx}} />
  if(id === "podFolderOpen") return <FolderOpenIcon fontSize={size} sx={{...sx}} />
  if(id === "podMaterial") return <MaterialIcon fontSize={size} sx={{...sx}} />
  if(id === "podNotes") return <NotesIcon fontSize={size} sx={{...sx}} />
  if(id === "podPeople") return <PeopleIcon fontSize={size} sx={{...sx}} />
  if(id === "podReadingQuestions") return <ReadingQuestionIcon fontSize={size} sx={{...sx}} />
  if(id === "podSettings") return <SettingsIcon fontSize={size} sx={{...sx}} />
  if(id === "podTags") return <TagIcon fontSize={size} sx={{...sx}} />

  if(id === "reply") return <ReplyIcon fontSize={size} sx={{...sx}} />
  if(id === "settings") return <MoreHorizIcon fontSize={size} sx={{...sx}} />
  if(id === "sortByAlphabet") return <SortByAlphaIcon fontSize={size} sx={{...sx}} />
  if(id === "sortByFrequency") return <SortIcon fontSize={size} sx={{...sx}} />
  if(id === "status") return <AdjustIcon fontSize={size} sx={{...sx}} />


  console.warn("could not find matching UxIcon id", id)
  return null
}

export default UxIcon
